import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-15',
  templateUrl: './15.component.html',
  styleUrls: ['./15.component.scss'],
})
export class VbList15Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
